import type { Staleness } from './time';

export interface StalenessMeta {
  color: string;
  glow: string;
  label: string;
}

const STALE_META: Record<Staleness, StalenessMeta> = {
  fresh: { color: 'var(--fresh)', glow: 'var(--fresh-soft)', label: 'Live' },
  stale: { color: 'var(--stale)', glow: 'var(--stale-soft)', label: 'Delayed' },
  'very-stale': { color: 'var(--offline)', glow: 'var(--offline-soft)', label: 'Offline' },
  unknown: { color: 'var(--offline)', glow: 'var(--offline-soft)', label: 'Offline' },
};

export function stalenessMeta(state: Staleness): StalenessMeta {
  return STALE_META[state];
}

/** Deterministic per-id accent color, so a user/device keeps the same color across renders and sessions. */
export function colorForId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  return `oklch(0.70 0.13 ${hue})`;
}

export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function batteryColor(percent: number | null): string {
  if (percent === null) return 'var(--dim)';
  if (percent <= 15) return 'var(--offline)';
  if (percent <= 35) return 'var(--stale)';
  return 'var(--dim)';
}
